// extracted by mini-css-extract-plugin
module.exports = {"root":"MessagesList_root__EQNXy","header":"MessagesList_header__2plWf","chat":"MessagesList_chat__1insp"};